<template>
  <v-card flat>
    <v-app-bar
      app
      fade-img-on-scroll
      shrink-on-scroll
      dark
      src="https://www.imperial.ac.uk/ImageCropToolT4/imageTool/uploaded-images/180216_queens_tower_lgbt_month_002--tojpeg_1545305547967_x1.jpg"
      color="#225590"
    >
      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          position="center center"
          gradient="to top right, rgba(34,85,144,.9), rgba(34,85,144,.7)"
          alt="gb"
        ></v-img>
      </template>

      <v-layout>
        <v-flex style="font-size:1em">DoCSoc Sponsors Portal</v-flex>
        <SignOut></SignOut>
      </v-layout>

      <template v-slot:extension>
        <v-tabs v-model="activeTab" centered background-color="transparent">
          <v-spacer></v-spacer>
          <v-tab
            v-for="tab in tabs"
            :key="tab.rank"
            style="padding:10px"
            class="title"
          >
            <v-img class="mr-1" width="30px" :src="tab.icon"></v-img>
            {{ tab.rank }}
          </v-tab>
          <v-spacer></v-spacer>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-tabs-items v-model="activeTab">
      <v-tab-item flat v-for="tab in tabs" :key="tab.rank">
        <v-container>
          <v-layout v-if="tab.sponsors.length > 0" justify-center wrap>
            <v-flex
              v-for="sponsor in tab.sponsors"
              :key="sponsor.username"
              xs12
              md8
            >
              <Sponsors :Sponsor="sponsor"></Sponsors>
            </v-flex>
          </v-layout>
          <v-layout my-5 v-else justify-center wrap>
            No Sponsors yet. Come back later
          </v-layout>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
    <Footer></Footer>
  </v-card>
</template>

<script>
import Sponsors from "../components/Members/Sponsor";
import SignOut from "../components/SignOut";
import { db } from "../plugins/firebase";
import Footer from "../components/Footer";

export default {
  fiery: true,
  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          rank: "Gold",
          sponsors: this.$fiery(db.collection("Sponsors"), {
            query: sponsors =>
              sponsors.where("rank", "==", "Gold").orderBy("bespoke", "desc"),
            sub: {
              opportunities: {
                sub: {
                  applications: {
                    query: applications =>
                      applications.where(
                        "user",
                        "==",
                        this.$store.state.user.Login
                      )
                  }
                }
              }
            }
          }),
          icon: require("../assets/images/icons/gold.png")
        },
        {
          rank: "Silver",
          sponsors: this.$fiery(db.collection("Sponsors"), {
            query: sponsors =>
              sponsors.where("rank", "==", "Silver").orderBy("bespoke", "desc"),
            sub: {
              opportunities: {
                sub: {
                  applications: {
                    query: applications =>
                      applications.where(
                        "user",
                        "==",
                        this.$store.state.user.Login
                      )
                  }
                }
              }
            }
          }),
          icon: require("../assets/images/icons/silver.png")
        },
        {
          rank: "Bronze",
          sponsors: this.$fiery(db.collection("Sponsors"), {
            query: sponsors =>
              sponsors.where("rank", "==", "Bronze").orderBy("bespoke", "desc"),
            sub: {
              opportunities: {
                sub: {
                  applications: {
                    query: applications =>
                      applications.where(
                        "user",
                        "==",
                        this.$store.state.user.Login
                      )
                  }
                }
              }
            }
          }),
          icon: require("../assets/images/icons/bronze.png")
        }
      ]
    };
  },
  components: { Sponsors, SignOut, Footer }
};
</script>

